import * as React from 'react';

interface IFormLabelProps {
    text?: string;
    required?: boolean;
}

class FormLabel extends React.Component<IFormLabelProps> {
    public render() {
        const { text, required } = this.props;

        let modLabel: JSX.Element | void = undefined;

        if (!this.props.text) {
            return this.props.children;
        }

        if (required) {
            modLabel = (
                <>
                    {text}
                    <span className="lh-required-indicator">*</span>
                </>
            );
        }
        return (
            <label className="bp3-label">
                {modLabel || text}
                {this.props.children}
            </label>
        );
    }
}

export default FormLabel;



// WEBPACK FOOTER //
// ./src/components/controls/forms/FormLabel.tsx